// src/components/Banner.jsx
import React,{ useState } from 'react';
 import Slider from 'react-slick';
// import "slick-carousel/slick/slick.css"; 
// import "slick-carousel/slick/slick-theme.css";
// import banner1 from '../assets/images/Chilli-Banner-New.jpg';
// import banner2 from '../assets/images/website-banner-6.jpg';
// import banner3 from '../assets/images/website-banner-5.jpg';
// import banner4 from '../assets/images/website-banner-8.jpg';
// import banner5 from '../assets/images/website-banner-9.jpg';
import { Link } from 'react-router-dom';


const Banner = () => {

   const [loading, setLoading] = useState(true);
   // react-slick keeps clones of every slide mounted for its infinite-loop
   // effect, so the hero videos are only rendered (and fetched) for the
   // slide that's actually active, instead of relying on autoplay/preload
   // hints which slick's cloning defeats.
   const [currentSlide, setCurrentSlide] = useState(0);

    const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,  // 👈 keeps autoplay running on hover
    pauseOnFocus: false,   // 👈 also prevents pause when clicking
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
  };

  return (
    <section className="banner section-desktop">
    <div className="container-full">
        <div id="carouselBanner" className="carousel masthead-banner no-gradient slide" data-ride="carousel">

            {/* <ol className="carousel-indicators slick-dots">

                <li data-target="#carouselBanner" data-slide-to='0' className='active'></li>

                <li data-target="#carouselBanner" data-slide-to='1' className=''></li>

                <li data-target="#carouselBanner" data-slide-to='2' className=''></li>

                <li data-target="#carouselBanner" data-slide-to='3' className=''></li>

                <li data-target="#carouselBanner" data-slide-to='4' className=''></li>
            </ol>  */}

                  {/* <div className="carousel-inner"> */}
                   <Slider {...settings}>
                <div className='carousel-item active slider-wrapper'>
                {currentSlide === 0 ? (
                   <video
          className="d-block w-100 slider-video"
          autoPlay
          muted
          loop
          playsInline
          style={{ height: '600px', objectFit: 'cover' }}
        >
          <source src="assets/images/Black pepper1.mp4" type="video/mp4" />
        </video>
                   ) : (
                   <div className="d-block w-100" style={{ height: '600px', background: '#0b2e16' }} />
                   )}
                    <div className="carousel-content">
                        <div className="container">
                            <div className="carousel-caption theme-29">
                                <span className="bg_span01"></span>

                                <h2>SPICES</h2>
                                <p>Your one-stop destination for every <br/> spice requirement</p>
                                <div className="carousel-button-block">
                                     <Link className="default-button01" to="/about/overview">READ MORE</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='carousel-item slider-wrapper'>
                {currentSlide === 1 ? (
                <video
                className="d-block w-100 slider-video"
                autoPlay
                muted
                loop
                playsInline
                style={{ height: '600px',objectFit: 'cover' }}
                >
                <source src="assets/images/bird view 2.mp4" type="video/mp4" />
                </video>
                ) : (
                <div className="d-block w-100" style={{ height: '600px', background: '#0b2e16' }} />
                )}
                    <div className="carousel-content">
                        <div className="container">
                            <div className="carousel-caption theme-29">
                                <span className="bg_span01"></span>
                                 <h2>ABOUT CORNERSTONE</h2>
                                <p>Welcome To Cornerstone</p>

                                <div className="carousel-button-block">
                                    <Link className="default-button01" to="/about/overview">READ MORE</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='carousel-item '>
                    <img alt="Power in every drop" className="d-block w-100" style={{ height: '600px', objectFit: 'cover', objectPosition: 'center 65%' }} src="assets/images/brand/banner_oleoresin_wide.jpg" />
                    <div className="carousel-content">
                        <div className="container">
                            <div className="carousel-caption theme-29" style={{ maxWidth: 460 }}>
                                <h1 style={{ marginBottom: 10 }}>POWER IN EVERY <span style={{ color: 'var(--brand-gold-light)' }}>DROP</span></h1>
                                <p style={{ color: 'var(--brand-gold-light)', fontSize: 16, marginBottom: 4, marginTop: 10 }}>Extracts of Exceptional Purity</p>
                                <p style={{ fontSize: 14 }}>Oleoresins &nbsp;|&nbsp; Essential Oils &nbsp;|&nbsp; Spice Extracts</p>
                                <div className="carousel-button-block">
                                    <Link className="default-button01" to="/about/overview">READ MORE</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='carousel-item '>
                    <img alt="Banner images" data-src="assets/images/Chilli-Banner-New.jpg" className="d-block w-100 lazyload" src="assets/images/Chilli-Banner-New.jpg"/><noscript><img className="d-block w-100" src='assets/images/Chilli-Banner-New.jpg' alt="Banner images"/></noscript>
                    <div className="carousel-content">
                        <div className="container">
                            <div className="carousel-caption theme-29">
                                <span className="bg_span01"></span>
                                <h1>NATURAL ANTI-OXIDANTS</h1>
                                <p>Bold Flavors. Naturally Preserved.</p>

                                <div className="carousel-button-block">
                                    <Link className="default-button01" to="/about/overview">READ MORE</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='carousel-item '>
                    <img alt="Banner images" data-src="assets/images/website-banner-8.jpg" className="d-block w-100 lazyload" src="assets/images/website-banner-8.jpg"/><noscript><img className="d-block w-100" src='assets/images/website-banner-8.jpg' alt="Banner images"/></noscript>
                    <div className="carousel-content">
                        <div className="container">

                            <div className="carousel-caption theme-29">

                                <span className="bg_span01"></span>
                                <h1>NATURAL COLOURS</h1>
                                <p>"Nature’s Palette Vibrance Without Compromise"</p>

                                <div className="carousel-button-block">
                                    <Link className="default-button01" to="/about/overview">READ MORE</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='carousel-item '>
                    <img alt="Banner images" data-src="assets/images/website-banner-6.jpg" className="d-block w-100 lazyload" src="assets/images/website-banner-6.jpg"/><noscript><img className="d-block w-100" src='assets/images/website-banner-6.jpg' alt="Banner images"/></noscript>
                    <div className="carousel-content">
                        <div className="container">
                            <div className="carousel-caption theme-29">
                                <span className="bg_span01"></span>
                                 <h1>CULINARY PLATFORMS</h1>
                                <p>Crafting Global Flavours, Bringing World Cuisines to Life</p>

                                <div className="carousel-button-block">
                                  <Link className="default-button01" to="/about/overview">READ MORE</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
</Slider>
            {/* </div> */}
        </div>

        <div className="social-feed-wrap" data-aos="fade-up" data-aos-anchor-placement="top-bottom">
            <div className="container">
                <div className="social-feed-block">
                    {/* <!--<h5>Explore what we are sharing in social media now!</h5>
        <a href="social-feeds/index.html" className="default-button">VIEW OUR SOCIAL MEDIA FEED</a>--> */}
                </div>
            </div>
        </div>
    </div>
</section>
  );
};

export default Banner;